import React from "react";
import moment from "moment";
import Popup from "../../EventOrganiser/Popup";
import TopicForm from "../WeeklyLessons/TopicForm";
import HomeWorkForm from "../WeeklyLessons/HomeWorkForm";
import AllProjects from "../WeeklyLessons/Projects/AllProjects";
import { useSelector } from "react-redux";

export default function LessonsTable({
    styles,
    currentWeekData = [],
    expandedRows,
    toggleExpandRow,
    handleIconClick,
    handleStatusIconClick,
    findMatchForRow,
    isOpen,
    isHomeWork,
    isProject,
    dispatch,
    clearPopupInfo,
    closeHwPopup,
    closeProjectPopup,
    statusPopup,
    setStatusPopup,
    handleStatusSubmit
}) {
    const { allTopics } = useSelector((state) => state.topic);
    return (
        <div className="lesson-table-container">
            <table className="lesson-table">

                <thead>
                    <tr style={{ backgroundColor: "#e3f2fd" }}>
                        {[
                            "Day",
                            "Period",
                            "Class",
                            "Subject",
                            "Chapter",
                            "Topic",
                            "Homework",
                            "Projects",
                            "Remarks",
                            "Status",
                        ].map((header, idx) => (
                            <th
                                key={idx}
                                style={{
                                    ...styles.th,
                                    position: "sticky",
                                    top: 0,
                                    background: "#e3f2fd",
                                }}
                            >
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {Array.isArray(currentWeekData) && currentWeekData.length > 0 ? (
                        currentWeekData.map((row) => {

                            const topicText = findMatchForRow(row, "topic")?.trim() || row?.topic || "";
                            const homeworkText =
                                findMatchForRow(row, "homework")?.trim() || row?.homework || "";

                            const rowKey = `${row?.sno}-${row?.period?.date}`;

                            return (
                                <tr key={rowKey}>

                                    {/* DAY */}
                                    <td style={{ ...styles.td, width: "8%" }}>
                                        <strong>
                                            {row?.period?.date
                                                ? moment(row.period.date).format("dddd")
                                                : "-"}
                                        </strong>
                                        <br />
                                        <small>{row?.period?.date || "-"}</small>
                                    </td>

                                    {/* PERIOD */}
                                    <td style={{ ...styles.td, width: "6%" }}>
                                        {row?.period?.period_name || "-"}
                                    </td>

                                    {/* CLASS */}
                                    <td style={{ ...styles.td, width: "8%" }}>
                                        {row?.className || "-"}
                                    </td>

                                    {/* SUBJECT */}
                                    <td style={{ ...styles.td, width: "10%" }}>
                                        {row?.subjectName || "-"}
                                    </td>

                                    {/* CHAPTER */}
                                    <td style={{ ...styles.td, width: "15%" }}>
                                        {row?.chapter || "-"}
                                    </td>

                                    {/* TOPIC */}
                                    <td style={{ ...styles.td, width: "20%", position: "relative" }}>
                                        {topicText.length > 30 && !expandedRows[`topic-${rowKey}`] ? (
                                            <>
                                                {topicText.slice(0, 30)}...
                                                <span
                                                    onClick={() => toggleExpandRow(`topic-${rowKey}`)}
                                                    style={{ color: "blue", cursor: "pointer", marginLeft: 5 }}
                                                >
                                                    View More
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                {topicText || "-"}
                                                {topicText.length > 30 && (
                                                    <span
                                                        onClick={() => toggleExpandRow(`topic-${rowKey}`)}
                                                        style={{ color: "blue", cursor: "pointer", marginLeft: 5 }}
                                                    >
                                                        View Less
                                                    </span>
                                                )}
                                            </>
                                        )}

                                        <i
                                            className={`fa ${topicText ? "fa-edit" : "fa-plus"}`}
                                            style={{
                                                position: "absolute",
                                                top: 5,
                                                right: 5,
                                                cursor: "pointer",
                                                color: "#007bff",
                                            }}
                                            onClick={() => handleIconClick("lesson", row)}
                                        />
                                    </td>

                                    {/* HOMEWORK */}
                                    <td style={{ ...styles.td, width: "20%", position: "relative" }}>
                                        {homeworkText.length > 30 && !expandedRows[`hw-${rowKey}`] ? (
                                            <>
                                                {homeworkText.slice(0, 30)}...
                                                <span
                                                    onClick={() => toggleExpandRow(`hw-${rowKey}`)}
                                                    style={{ color: "blue", cursor: "pointer", marginLeft: 5 }}
                                                >
                                                    View More
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                {homeworkText || "-"}
                                                {homeworkText.length > 30 && (
                                                    <span
                                                        onClick={() => toggleExpandRow(`hw-${rowKey}`)}
                                                        style={{ color: "blue", cursor: "pointer", marginLeft: 5 }}
                                                    >
                                                        View Less
                                                    </span>
                                                )}
                                            </>
                                        )}

                                        <i
                                            className={`fa ${homeworkText ? "fa-edit" : "fa-plus"}`}
                                            style={{
                                                position: "absolute",
                                                top: 5,
                                                right: 5,
                                                cursor: "pointer",
                                                color: "#007bff",
                                            }}
                                            onClick={() => handleIconClick("homework", row)}
                                        />
                                    </td>

                                    {/* PROJECT */}
                                    <td style={{ ...styles.td, width: "5%", textAlign: "center" }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                backgroundColor: "#e6f2ff",
                                                borderRadius: "50%",
                                                width: "35px",
                                                height: "35px",
                                                margin: "auto",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => handleIconClick("project", row)}
                                        >
                                            <i
                                                className="fa fa-plus"
                                                style={{ color: "#007bff", fontSize: "16px" }}
                                            />
                                        </div>
                                    </td>

                                    {/* REMARKS */}
                                    <td style={{ ...styles.td, width: "8%" }}>
                                        -
                                    </td>

                                    {/* STATUS */}
                                    <td style={{ ...styles.td, width: "3%", textAlign: "center" }}>
                                        {(() => {
                                            // 1. Find the specific record for this row
                                            const matchedRecord = allTopics.find(
                                                (topic) => String(topic.schedule_id) === String(row.schedule_id)
                                            );

                                            // 2. Extract status. If the record exists but status is null (like your IDs 23/24), 
                                            // or if no record exists at all, default to "3" (In Progress)
                                            const status = row.status || "3";
                                            console.log(status, "stauts ");
                                            const labels = { "1": "Pending", "2": "Completed", "3": "In Progress" };
                                            const colors = { "1": "#ef4444", "2": "#22c55e", "3": "#f59e0b" };

                                            return (
                                                <button
                                                    onClick={() => handleStatusIconClick(row)}
                                                    style={{
                                                        padding: "4px 12px",
                                                        borderRadius: "20px",
                                                        border: `1.5px solid ${colors[status] || "#f59e0b"}`,
                                                        cursor: "pointer",
                                                        fontWeight: "600",
                                                        fontSize: "12px",
                                                        backgroundColor: `${colors[status] || "#f59e0b"}15`,
                                                        color: colors[status] || "#f59e0b",
                                                        whiteSpace: "nowrap"
                                                    }}
                                                >
                                                    {labels[status] || "In Progress"}
                                                </button>
                                            );
                                        })()}
                                    </td>

                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="10" style={{ textAlign: "center", padding: 20 }}>
                                No data found
                            </td>
                        </tr>
                    )}
                </tbody>

            </table>

            {/* POPUPS */}

            {isOpen && (
                <Popup
                    title="Add Topic"
                    height="300px"
                    maxWidth="600px"
                    onClose={() => dispatch(clearPopupInfo())}
                    minHeight="500px"
                >
                    <TopicForm />
                </Popup>
            )}

            {isHomeWork && (
                <Popup
                    title="Add Home Work"
                    height="300px"
                    maxWidth="600px"
                    onClose={() => dispatch(closeHwPopup())}
                    minHeight="500px"
                >
                    <HomeWorkForm />
                </Popup>
            )}

            {isProject && (
                <Popup
                    title="Projects"
                    height="500px"
                    maxWidth="1200px"
                    onClose={() => dispatch(closeProjectPopup())}
                    minHeight="650px"
                >
                    <AllProjects />
                </Popup>
            )}

            {statusPopup.isOpen && (
                <Popup
                    title="Change Lesson Status"
                    onClose={() => setStatusPopup({ ...statusPopup, isOpen: false })}
                    height="auto"
                    maxWidth="400px"
                >
                    <div style={{ padding: "20px" }}>
                        <div style={{ marginBottom: "15px" }}>
                            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Select Status</label>
                            <select
                                className="form-select"
                                value={statusPopup.selectedStatus}
                                onChange={(e) => setStatusPopup({ ...statusPopup, selectedStatus: e.target.value })}
                            >
                                <option value="3">In Progress</option>
                                <option value="1">Pending</option>
                                <option value="2">Completed</option>
                            </select>
                        </div>

                        {statusPopup.selectedStatus === "1" && (
                            <div style={{ marginBottom: "15px" }}>
                                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Reason for Pending</label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    placeholder="Enter reason..."
                                    value={statusPopup.reason}
                                    onChange={(e) => setStatusPopup({ ...statusPopup, reason: e.target.value })}
                                />
                            </div>
                        )}

                        <div style={{ textAlign: "right", marginTop: "20px" }}>
                            <button
                                className="btn btn-secondary me-2"
                                onClick={() => setStatusPopup({ ...statusPopup, isOpen: false })}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleStatusSubmit}
                                disabled={statusPopup.selectedStatus === "1" && !statusPopup.reason.trim()}
                            >
                                Update Status
                            </button>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    );
}
